"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.function.name");

var _react = _interopRequireWildcard(require("react"));

var _reactKonva = require("react-konva");

var _ramda = require("ramda");

var _elementProps = _interopRequireDefault(require("./elementProps"));

var _withElementHandlers = _interopRequireDefault(require("../hocs/withElementHandlers"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Curve =
/*#__PURE__*/
function (_Component) {
  _inherits(Curve, _Component);

  function Curve() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Curve);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Curve)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.sceneFunc = function (context, shape) {
      var _this$props$element = _this.props.element,
          _this$props$element$a = _this$props$element.anchors,
          anchors = _this$props$element$a === void 0 ? [] : _this$props$element$a,
          x = _this$props$element.x,
          y = _this$props$element.y,
          close = _this$props$element.close;
      context.beginPath();
      var grouped = (0, _ramda.reduce)(function (res, cur) {
        var lastIsArray = (0, _ramda.is)(Array, (0, _ramda.last)(res));

        if (cur.bezier || !cur.bezier && lastIsArray && !(0, _ramda.any)((0, _ramda.propEq)('bezier', false), (0, _ramda.last)(res))) {
          var isCurve = lastIsArray && (0, _ramda.last)((0, _ramda.last)(res)).bezier;
          var lastAnchor = isCurve ? (0, _ramda.last)(res) : [];
          lastAnchor.push(cur);
          return [].concat(_toConsumableArray(isCurve ? (0, _ramda.dropLast)(1, res) : res), [lastAnchor]);
        } else {
          return [].concat(_toConsumableArray(res), [cur]);
        }
      }, [], anchors);
      (0, _ramda.forEach)(function (anchor, i) {
        if ((0, _ramda.is)(Array, anchor)) {
          var points = (0, _ramda.unnest)(anchor.map(function (_ref) {
            var aX = _ref.x,
                aY = _ref.y;
            return [aX - x, aY - y];
          }));

          if (points.length === 2) {
            context.lineTo.apply(context, _toConsumableArray(points));
          }

          if (points.length === 4) {
            context.quadraticCurveTo.apply(context, _toConsumableArray(points));
          } else {
            context.bezierCurveTo.apply(context, _toConsumableArray(points));
          }
        } else {
          if (i === 0) {
            context.moveTo(anchor.x - x, anchor.y - y);
          } else {
            context.lineTo(anchor.x - x, anchor.y - y);
          }
        }
      }, grouped);
      close && context.closePath();
      context.fillStrokeShape(shape);
    };

    return _this;
  }

  _createClass(Curve, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          element = _this$props.element,
          onDragMove = _this$props.onDragMove,
          onTransform = _this$props.onTransform;
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_reactKonva.Shape, _extends({}, element, {
        opacity: 0,
        strokeWidth: 5,
        name: "".concat(element.name, "-helper"),
        sceneFunc: this.sceneFunc,
        onDragMove: onDragMove,
        draggable: true
      })), _react.default.createElement(_reactKonva.Shape, _extends({}, element, {
        sceneFunc: this.sceneFunc,
        onDragMove: onDragMove,
        onTransform: onTransform,
        draggable: true
      })));
    }
  }]);

  return Curve;
}(_react.Component);

Curve.propTypes = _objectSpread({}, _elementProps.default);

var _default = (0, _withElementHandlers.default)(Curve);

exports.default = _default;